import { render } from "./Summary.vue?vue&type=template&id=507ca89d&scoped=true&ts=true"
import script from "./Summary.vue?vue&type=script&lang=ts"
export * from "./Summary.vue?vue&type=script&lang=ts"

import "./Summary.vue?vue&type=style&index=0&id=507ca89d&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-507ca89d"]])

export default __exports__